import type {ReactElement} from 'react';
import React from 'react';
import {CameraAndMicrophonePermissionDeniedMessage} from '@Panels/record-image-and-video-panel/components/camera-and-microphone-permission-denied-message';
import {RepromptCameraAndMicrophonePermission} from '@Panels/record-image-and-video-panel/components/reprompt-camera-and-microphone-permission';
import {updateOptionsPanelHeight} from '@Components/poster-editor/library/poster-editor-library';
import {isIOS} from 'react-device-detect';
import {isMobileSize} from '@Libraries/record-image-and-video.library';
import useWindowSize from '@Hooks/useWindowSize';
import {CheckSystemPermissionsMessage} from '@Panels/record-image-and-video-panel/components/check-system-permissions-message';

interface CameraAndMicrophonePermissionProps {
  rempromptForPermissions?: boolean;
  onReprompt?: () => Promise<void>;
  permissionsDeniedError?: boolean;
  checkSystemPermissionsError?: boolean;
  panelId?: string;
}

export function CameraAndMicrophonePermission({
  panelId = '',
  rempromptForPermissions = false,
  permissionsDeniedError = false,
  checkSystemPermissionsError = false,
  ...props
}: CameraAndMicrophonePermissionProps): ReactElement | null {
  const getPermissionErrorMessage = (): ReactElement | null => {
    const {windowWidth} = useWindowSize();

    if (permissionsDeniedError) {
      return <CameraAndMicrophonePermissionDeniedMessage />;
    }
    if (checkSystemPermissionsError) {
      return <CheckSystemPermissionsMessage />;
    }
    if (rempromptForPermissions && props.onReprompt) {
      return (
        <RepromptCameraAndMicrophonePermission
          onInitiatePrompt={async () => {
            if (isMobileSize(windowWidth)) {
              updateOptionsPanelHeight(panelId, `${1000}px`);
            } else if (isIOS) {
              updateOptionsPanelHeight(panelId, `${5000}px`);
            } else {
              updateOptionsPanelHeight(panelId, `${628}px`);
            }

            if (props.onReprompt) {
              await props.onReprompt();
            }
          }}
        />
      );
    }
    return null;
  };

  return getPermissionErrorMessage();
}
